<template>
  <div class="base-searchbar">
    <base-form
      ref="form"
      v-model="form"
      @change="formChange"
      :form-items="formItems"
      :label-width="labelWidth"
      input-trim
      inline
    ></base-form>
    <el-button-group
      v-if="Array.isArray(buttons) && buttons.length > 0"
      style="padding: 4px 0"
    >
      <el-button
        v-for="(btn, index) in buttons"
        :key="index"
        :size="btn.size || 'small'"
        v-bind="btn.bind"
        v-on="btn.on"
        >{{ btn.label }}</el-button
      >
    </el-button-group>
  </div>
</template>

<script>
export default {
  name: 'base-searchbar', //兼容新组件名称定义
  props: {
    value: Object,
    formItems: Array,
    labelWidth: String,
    buttons: Array,
    sendJson: Boolean,
  },
  data() {
    return {
      form: {},
      searchCond: {},
    }
  },
  methods: {
    parseCondValue(val) {
      if (!val && typeof val != 'boolean') return []
      if (Array.isArray(val)) return val
      return [val]
    },
    resetForm() {
      for (var key in this.form) {
        this.$set(this.form, key, '')
      }
    },
    formChange(newVal) {
      for (var i in this.formItems) {
        var item = this.formItems[i]
        var val = newVal[item.prop]

        if (item.cp || item.cp == 0) {
          var Values = this.parseCondValue(val)
          if (Values == 0) {
            this.$set(this.searchCond, item.prop, null)
          } else {
            var temp = {
              Field: item.field || item.prop,
              ComparePattern: item.cp,
              Values,
            }
            this.$set(
              this.searchCond,
              item.prop,
              this.sendJson ? temp : JSON.stringify(temp)
            )
          }
        } else {
          this.$set(this.searchCond, item.prop, val)
        }
      }
      this.$emit('input', this.searchCond)
    },
  },
}
</script>

<style>
.toolbar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 0 10px 20px;
  z-index: 2;
  display: flex;
}
.toolbar .el-form {
  padding-top: 4px;
}
.toolbar .el-form-item {
  margin-bottom: 0;
}

.search-input-wrap {
  height: 40px;
  overflow: hidden;
  padding-bottom: 5px;
}
.search-input-wrap:hover {
  height: auto;
  overflow: visible;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
